// src/api/endpoints/UserAPI.js
export class UserAPI {
  constructor(apiClient) {
    this.api = apiClient;
  }

  login(username, password) {
    return this.api.request({
      url: '/api/v1/login',
      method: 'POST',
      data: { username, password },
    });
  }

  requestOtp(username) {
    return this.api.request({
      url: '/api/v1/login/otp/request',
      method: 'POST',
      data: { username },
    });
  }

  resendOtp(otp_access_token) {
    return this.api.request({
      url: '/api/v1/login/otp/resend',
      method: 'POST',
      data: { otp_access_token },
    });
  }

  verifyOtp(otp_access_token, otp) {
    return this.api.request({
      url: '/api/v1/login/otp/verify',
      method: 'POST',
      data: { otp_access_token, otp },
    });
  }

  refreshToken(refresh_token) {
    return this.api.request({
      url: '/api/v1/login/refresh',
      method: 'POST',
      data: { refresh_token },
    });
  }

  logout(refresh_token) {
    return this.api.request({
      url: '/api/v1/logout',
      method: 'POST',
      data: { refresh_token },
    });
  }

  changePassword(data) {
    return this.api.request({
      url: '/api/v1/user/change-password',
      method: 'POST',
      data,
    });
  }

  getActiveUserTypes() {
    return this.api.request({
      url: '/api/v1/user-types/active/list',
      method: 'GET',
    });
  }

  getMyPermissions() {
    return this.api.request({
      url: '/api/v1/user/acl',
      method: 'GET',
    });
  }
}
